export default __webpack_public_path__ + "static/media/logo.ffabbb22.svg";